import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      ar: {
        translation: {
          nav: {
            home: "الرئيسية",
            about: "من نحن",
            services: "خدماتنا",
            blogs: "المدونات",
            contact: "اتصل بنا"
          },
          aria: {
            language: "تغيير اللغة",
            navigation: "فتح قائمة التنقل"
          },
          lang_toggle: "EN",
          form: {
            main_title: "تواصل معنا اليوم",
            sub_title: "لنناقش مشروعك ونقدم لك الحل الأمثل لاحتياجاتك",
            section_contact: "معلومات الاتصال",
            section_interest: "الاهتمام بالخدمة",
            section_time: "الوقت المفضل للاتصال",
            section_additional: "معلومات إضافية",
            submit_btn: "جدولة مكالمتي",
            sending: "جاري الإرسال...",
            loading: "جاري التحميل...",
            no_days: "لا توجد أيام متاحة",
            select_day: "اختر اليوم",
            select_time: "اختر الوقت",
            select_day_first: "حدد اليوم أولاً",
            availability_error: "تعذر تحميل المواعيد المتاحة. يرجى المحاولة لاحقاً."
          },
          labels: {
            fullName: "الاسم الكامل *",
            company: "الشركة (اختياري)",
            email: "عنوان البريد الإلكتروني *",
            phone: "رقم الهاتف *",
            service: "ما الخدمة التي تهتم بها؟ *",
            purpose: "الغرض الرئيسي من هذه المكالمة *",
            day: "اليوم المفضل *",
            time: "الوقت المفضل *",
            urgency: "مستوى الاستعجال *",
            message: "أخبرنا عن مشروعك أو أسئلتك *",
            placeholder_name: "الاسم الكامل",
            placeholder_company: "اسم الشركة",
            placeholder_message: "اكتب تفاصيل مشروعك هنا...",
            select_default: "اختر الخدمة...",
            purpose_default: "حدد الغرض...",
            urgency_default: "حدد مستوى الاستعجال..."
          },
          options: {
            services: {
              web: "تصميم وبرمجة المواقع الإلكترونية",
              apps: "برمجة وتطوير تطبيقات الهواتف الذكية",
              ecommerce: "التجارة الإلكترونية",
              erp: "الأنظمة المتكاملة ERP",
              ai: "حلول الذكاء الاصطناعي المتقدمة"
            },
            purposes: {
              appointment: "طلب حجز موعد",
              consultation: "طلب استشارة تقنية",
              pricing: "معرفة سعر الخدمة وتفاصيلها"
            },
            urgency_levels: {
              low: "منخفض - خلال 48 ساعة",
              medium: "متوسط - خلال 24 ساعة",
              high: "مستعجل - اليوم",
              immediate: "فوري - خلال ساعتين"
            }
          },
          validation: {
            name_short: "الاسم قصير جداً",
            name_req: "يرجى إدخال الاسم الكامل",
            email_invalid: "صيغة البريد الإلكتروني غير صحيحة",
            email_en_only: "يجب كتابة البريد الإلكتروني بالأحرف الإنجليزية فقط",
            email_req: "البريد الإلكتروني مطلوب",
            phone_num_only: "رقم الهاتف يجب أن يحتوي على أرقام فقط",
            phone_len: "رقم الهاتف يجب أن يتكون من 8 أرقام بالضبط",
            phone_req: "رقم الهاتف مطلوب للاتصال بك",
            service_req: "يرجى اختيار الخدمة المطلوبة",
            purpose_req: "يرجى تحديد الغرض من المكالمة",
            slot_req: "يرجى اختيار وقت للمكالمة",
            urgency_req: "يرجى تحديد مستوى الاستعجال",
            message_req: "يرجى كتابة تفاصيل بسيطة عن مشروعك"
          },
          messages: {
            loading_toast: "جاري حجز موعدك مع OnPoint...",
            success: "تم حجز الموعد بنجاح!",
            error_unexpected: "حدث خطأ غير متوقع، يرجى المحاولة لاحقاً",
            webhook_missing: "إعدادات إرسال النموذج غير مكتملة. يرجى التواصل مع الدعم.",
            availability_error: "تعذر تحميل المواعيد المتاحة. يرجى المحاولة لاحقاً."
          }
        }
      },
      en: {
        translation: {
          nav: {
            home: "Home",
            about: "About Us",
            services: "Services",
            blogs: "Blogs",
            contact: "Contact US"
          },
          aria: {
            language: "Change language",
            navigation: "Open navigation menu"
          },
          lang_toggle: "AR",
          form: {
            main_title: "Contact Us Today",
            sub_title: "Let's discuss your project and provide the perfect solution for your needs",
            section_contact: "Contact Information",
            section_interest: "Service Interest",
            section_time: "Preferred Call Time",
            section_additional: "Additional Information",
            submit_btn: "Schedule My Call",
            sending: "Sending...",
            loading: "Loading...",
            no_days: "No available days",
            select_day: "Select Day",
            select_time: "Select Time",
            select_day_first: "Select day first",
            availability_error: "Unable to load available times. Please try again later."
          },
          labels: {
            fullName: "Full Name *",
            company: "Company (Optional)",
            email: "Email Address *",
            phone: "Phone Number *",
            service: "Which service are you interested in? *",
            purpose: "Main purpose of this call *",
            day: "Preferred Day *",
            time: "Preferred Time *",
            urgency: "Urgency Level *",
            message: "Tell us about your project or questions *",
            placeholder_name: "Full Name",
            placeholder_company: "Company Name",
            placeholder_message: "Write your project details here...",
            select_default: "Select service...",
            purpose_default: "Select purpose...",
            urgency_default: "Select urgency..."
          },
          options: {
            services: {
              web: "Web Design & Development",
              apps: "Mobile App Development",
              ecommerce: "E-Commerce",
              erp: "Integrated ERP Systems",
              ai: "Advanced AI Solutions"
            },
            purposes: {
              appointment: "Book an Appointment",
              consultation: "Technical Consultation",
              pricing: "Pricing & Details"
            },
            urgency_levels: {
              low: "Low - within 48 hours",
              medium: "Medium - within 24 hours",
              high: "Urgent - Today",
              immediate: "Immediate - within 2 hours"
            }
          },
          validation: {
            name_short: "Name is too short",
            name_req: "Full name is required",
            email_invalid: "Invalid email format",
            email_en_only: "Email must be in English characters only",
            email_req: "Email is required",
            phone_num_only: "Phone number must contain digits only",
            phone_len: "Phone number must be exactly 8 digits",
            phone_req: "Phone number is required to contact you",
            service_req: "Please select a service",
            purpose_req: "Please specify the purpose",
            slot_req: "Please select a time slot",
            urgency_req: "Please specify urgency level",
            message_req: "Please provide project details"
          },
          messages: {
            loading_toast: "Booking your appointment with OnPoint...",
            success: "Appointment booked successfully!",
            error_unexpected: "An unexpected error occurred, please try again later",
            webhook_missing: "Form submission is not configured yet. Please contact support.",
            availability_error: "Unable to load available times. Please try again later."
          }
        }
      }
    },
    fallbackLng: "ar",
    interpolation: { escapeValue: false }
  });

export default i18n;
